.default-placeholder {
  @apply relative isolate overflow-hidden;

  &::after {
    content: '';
    @apply absolute;
    top: -150%;
    left: 0;
    width: 400%;
    height: 400%;
    background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    z-index: -1;
    animation: default-gradient 15s ease infinite;
    animation-delay: var(--placeholder-delay, 0s);
    animation-play-state: var(--placeholder-play-state, running);
    will-change: transform;
  }

  & > div {
    @apply bg-black/50 text-gray-200;
  }
}

@keyframes default-gradient {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-75%);
  }
}

.dark-purple-placeholder {
  @apply relative isolate overflow-hidden;
  background: #000;

  &::after {
    content: '';
    @apply absolute;
    inset: -50%;
    z-index: -1;
    background: conic-gradient(
      from 90deg,
      theme('colors.membership-gradient-stop.2' / 60%),
      theme('colors.membership-gradient-stop.0' / 60%),
      theme('colors.membership-gradient-stop.1' / 60%),
      theme('colors.membership-gradient-stop.2' / 60%)
    );
    animation:
      dark-purple-rotate 3.5s linear infinite,
      dark-purple-pulse 3.5s linear infinite;
    animation-delay: var(--placeholder-delay, 0s);
    animation-play-state: var(--placeholder-play-state, running);
    will-change: transform, opacity;
  }

  &::before {
    @apply bg-black;
    @apply absolute top-0 translate-x-5 translate-y-5 w-[calc(100%-40px)] h-[calc(100%-40px)];
    @apply blur-2xl;
    content: '';
  }

  & > div {
    @apply text-white;
  }
}

@keyframes dark-purple-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes dark-purple-pulse {
  0% {
    opacity: 0.583;
  }
  50%,
  52% {
    opacity: 1;
  }
  98%,
  100% {
    opacity: 0.583;
  }
}

.stopped-placeholder {
  background:
    radial-gradient(
      ellipse at 30% 20%,
      rgba(120, 50, 80, 0.25) 0%,
      transparent 60%
    ),
    radial-gradient(
      ellipse at 70% 80%,
      rgba(60, 40, 100, 0.2) 0%,
      transparent 60%
    ),
    #141318;

  & > div {
    @apply text-gray-300;
  }
}

.stopped-card {
  @apply flex flex-col items-center gap-1 px-5 py-3 rounded-2xl;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.stopped-mio {
  @apply drop-shadow-lg;
  height: 4.5rem;
  height: clamp(3rem, 20%, 6rem);
}

.animated-text-letter {
  display: inline-block;
  animation: animated-text 3s infinite cubic-bezier(0.19, 1, 0.22, 1);
  transform: translateZ(0);
  opacity: 0;
}

@keyframes animated-text {
  from {
    transform: translateZ(0) translateX(40px);
    opacity: 0;
  }
  60% {
    transform: translateZ(0) translateX(0px);
    opacity: 1;
  }
  to {
    transform: translateZ(0) translateX(5px);
    opacity: 0;
  }
}
